









import Vue from 'vue'

export default Vue.extend({
  name: 'TextInput',
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    keyName: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    input: ''
  }),
  watch: {
    value(val: string) {
      if (val) this.input = val
    }
  },
  methods: {
    onChange(e) {
      this.$emit('get-text-input-value', this.keyName, e.target.value)
    }
  }
})
